'use client';

import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { useI18n } from '@udemy-v2/i18n';
import { Button } from '@udemy-v2/react-core-components';
import styles from './course-limited-access.module.scss';
import { OnePaneLayoutContainer } from '@udemy-v2/react-layout-components';
interface CourseLimitedAccessProps {
  buttonLabel: string;
  onButtonClick: () => void;
  buttonDisabled?: boolean;
  children?: React.ReactNode;
}
export function CourseLimitedAccess(t0) {
  const $ = _c(13);
  const {
    buttonLabel,
    onButtonClick,
    buttonDisabled,
    children
  } = t0;
  const {
    gettext
  } = useI18n();
  let t1;
  if ($[0] !== gettext) {
    t1 = gettext("This is a private course.");
    $[0] = gettext;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <h1 className={`ud-heading-xl ${styles.heading}`}>{t1}</h1>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Icon glyph="lock" label={false} size="xsmall" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== buttonDisabled || $[6] !== buttonLabel || $[7] !== onButtonClick) {
    t4 = <Button udStyle="primary" disabled={buttonDisabled} onClick={onButtonClick}>{t3}{buttonLabel}</Button>;
    $[5] = buttonDisabled;
    $[6] = buttonLabel;
    $[7] = onButtonClick;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== children || $[10] !== t2 || $[11] !== t4) {
    t5 = <OnePaneLayoutContainer><div className={styles.content}>{t2}{t4}{children}</div></OnePaneLayoutContainer>;
    $[9] = children;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}